import axiosInstance from "../../utils/axiosInstance";

const getPrices = async (params) => {
  const response = await axiosInstance.get(
    `price?limit=${params.pageSize}&skip=${
      (params.current - 1) * params.pageSize
    }&key=${params.key}&status=${params.status}`
  );
  return response.data.data;
};

const getPrice = async (id) => {
  const response = await axiosInstance.get(`price/${id}`);
  return response.data.data;
};

const createPrice = async (data) => {
  const response = await axiosInstance.post(`price`, data);
  return response.data.data;
};

const updatePrice = async (params) => {
  const response = await axiosInstance.put(`price/${params.id}`, params.data);
  return response.data.data;
};

const deletePrice = async (params) => {
  const response = await axiosInstance.delete(`price/${params.id}`);
  return response.data.data;
};

const updatePriceStatus = async (params) => {
  const response = await axiosInstance.put(`price/${params.id}`, params.data);
  return response.data.data;
};

const priceService = {
  getPrices,
  updatePrice,
  createPrice,
  updatePriceStatus,
  getPrice,
  deletePrice,
};

export default priceService;
